import { render, staticRenderFns } from "./ImageSwiper.vue?vue&type=template&id=39372f06&scoped=true"
import script from "./ImageSwiper.vue?vue&type=script&lang=js"
export * from "./ImageSwiper.vue?vue&type=script&lang=js"
import style0 from "./ImageSwiper.vue?vue&type=style&index=0&id=39372f06&prod&lang=less&scoped=true"
import style1 from "./ImageSwiper.vue?vue&type=style&index=1&id=39372f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39372f06",
  null
  
)

export default component.exports